export default function slugify(text = '') {
    return text
        .toString()
        .toLowerCase()
        .trim()
        .replace(/[\s_]+/g, '-')
        .replace(/[^\w\-а-яёіїєґ]+/gi, '')
        .replace(/-+/g, '-')
        .replace(/^-+|-+$/g, '')
        .replace(/[а-яёіїєґ]/gi, char => (char in MAP ? MAP[char] : char))
}

const MAP = {
    а: 'a', б: 'b', в: 'v', г: 'h', ґ: 'g',
    д: 'd', е: 'e', ё: 'yo', ж: 'zh', з: 'z',
    и: 'y', і: 'i', ї: 'yi', й: 'y', к: 'k',
    л: 'l', м: 'm', н: 'n', о: 'o', п: 'p',
    р: 'r', с: 's', т: 't', у: 'u', ф: 'f',
    х: 'kh', ц: 'ts', ч: 'ch', ш: 'sh',
    щ: 'shch', ы: 'y', ь: '', ъ: '', э: 'e', ю: 'yu',
    я: 'ya', є: 'ye'
}
